import Collection from '../../collection';
import FieldFormTemplateModule from './fields.form.template';
import Grid from '../../view/grid';

import { eq, hashify, mapEl } from '../../utils/arrays';




export default FieldFormTemplateModule.extend( {

    template: 'module/refbooks/fields.form.types',

    url() {
        return this.model.id
            ? `fields/${this.model.id}/edit/bound-types`
            : `fields/new/bound-types`;
    },

    finalizeOpen(field) {
        const {
            typesPage = 1, typesLimit = 10,
            typesSort = 'name', typesDirection = 'asc',
            typesSearch = '',
            rolesVisiblePage = 1, rolesVisibleLimit = 10,
            rolesVisibleSort = 'name', rolesVisibleDirection = 'asc',
            rolesEditablePage = 1, rolesEditableLimit = 10,
            rolesEditableSort = 'name', rolesEditableDirection = 'asc',
            rolesMode = 'VISIBILITY',
        } = this.state() || {};

        this.setState( { 
            typesPage, typesLimit, typesSort, typesDirection, typesSearch,
            rolesVisiblePage, rolesVisibleLimit, rolesVisibleSort, rolesVisibleDirection,
            rolesEditablePage, rolesEditableLimit, rolesEditableSort, rolesEditableDirection,
            rolesMode,
        } );

        this.options.rolesVisibleSorted = new Collection();
        this.options.rolesVisibleFiltered = new Collection();
        this.options.rolesVisibleResulted = new Collection();
        this.options.rolesEditableSorted = new Collection();
        this.options.rolesEditableFiltered = new Collection();
        this.options.rolesEditableResulted = new Collection();

        return this.reSortGrid().then( () => Promise.all( [this.reSortRolesVisibleGrid(), this.reSortRolesEditableGrid()] ) )
            .then( () => {
                // hack to allow reFilterGrid work
                // TODO remove this hack
                this.model = field;
                this.reFilterGrid();
                this.reFilterRolesVisibleGrid();
                this.reFilterRolesEditableGrid();
                this.model = undefined;
            } )
            .then( () => this.bind( field ) );
    },

    finalizeStart(field) {
        this.listenTo( field, 'change:cluster', () => {
            this.setState( { typesPage: 1, } ), this.navigated();
            this.reFilterGrid();
        } );
        this.listenTo( this.model, 'change:is_for_all',
            () => {
                if (this.model.get( 'is_for_all' ) !== 'f')
                    this.$( '.-toggle-wrapper, .-toggle-all' ).addClass( '--invisible' );
                else
                    this.$( '.-toggle-wrapper, .-toggle-all' ).removeClass( '--invisible' );
                    
                this.Roles.render();
            } );
        this.listenTo( field, 'change:visible', () =>
            this.Roles.render() );
        this.listenTo( field, 'change:editable_by_default', () =>
            this.Roles.render() );
        this.listenTo( field, 'change:editable_inverted_for_roles', () =>
            this.Roles.render() );
    },

    serialize() {
        const { 
            typesSort, typesDirection, typesSearch, 
            rolesVisibleSort, rolesVisibleDirection,
            rolesEditableSort, rolesEditableDirection,
        } = this.state();

        const { 
            typesFiltered, typesResulted, 
            rolesVisibleFiltered, rolesVisibleResulted,
            /*rolesEditableFiltered,*/ rolesEditableResulted,
        } = this.options;

        return {
            typesSearch, 
            typesSort, typesDirection, 
            rolesVisibleSort, rolesVisibleDirection,
            rolesEditableSort, rolesEditableDirection,

            rolesMode: () => this.state().rolesMode,

            current: () =>
                typesResulted.current(),

            currentRule: () =>
                currentRule( this.model, typesResulted.current() ),

            currentVisibleRoles: () =>
                findVisibleRoles.call( this, this.model, typesResulted.current() ),

            currentEditableRoles: () =>
                findEditableRoles.call( this, this.model, typesResulted.current() ),

            currentEnabledRoles: () =>
                // no matter, visible or editable
                this.getAvailableFilteredModelIds( rolesVisibleFiltered ),

            visibleByDefaultToggled: () => {
                const rule = currentRule( this.model, typesResulted.current() );
                return rule && [true, 't'].includes( rule.visible_by_default )
            },

            editableByDefaultToggled: () => {
                const rule = currentRule( this.model, typesResulted.current() );
                if (rule)
                    if (rule.editable_by_default != null)
                        return [true, 't'].includes( rule.editable_by_default );

                return [true, 't'].includes( this.model.get( 'editable_by_default' ) );
            },

            hasDiff: () => this.hasDiff(),

            types: typesFiltered, rows: typesResulted,

            checkedTypes: () => this.model.get( 'bindings' )
                .filter( binding => [undefined, true, 't'].includes( binding.on ) )
                .map( binding => binding.type.id ),

            clusters: this.options.clusters,
            rolesVisibleRows: rolesVisibleResulted,
            rolesEditableRows: rolesEditableResulted,
        };
    },

    events: {

        'click .-sort'({currentTarget}) {
            const { sort, direction, } = currentTarget.dataset;
            if ( this.$( currentTarget ).closest( '[name="Grid"]' ).length)
                this.setState( { typesPage: 1, typesSort: sort, typesDirection: direction, } );
            if ( this.$( currentTarget ).closest( '[name="RolesVisibleGrid"]' ).length)
                this.setState( { rolesVisiblePage: 1, rolesVisibleSort: sort, rolesVisibleDirection: direction, } );
            if ( this.$( currentTarget ).closest( '[name="RolesEditableGrid"]' ).length)
                this.setState( { rolesEditablePage: 1, rolesEditableSort: sort, rolesEditableDirection: direction, } );

            let rendering;
            if (this.$( currentTarget ).closest( '[name="Grid"]' ).length)
                rendering = this.reSortGrid().then( () => this.reFilterGrid() );
            if ( this.$( currentTarget ).closest( '[name="RolesVisibleGrid"]' ).length)
                rendering = this.reSortRolesVisibleGrid().then( () => this.reFilterRolesVisibleGrid() );
            if ( this.$( currentTarget ).closest( '[name="RolesEditableGrid"]' ).length)
                rendering = this.reSortRolesEditableGrid().then( () => this.reFilterRolesEditableGrid() );

            return rendering
                    // hack: to rerender grid caption with order direction
                    .then( () => this.render() )
                    .then( () => this.navigated() );
        },

        'click .-toggle-binding'({currentTarget}) {
            const { id } = currentTarget.dataset;

            const on = currentTarget.checked;
            const oldBindings = this.model.get( 'bindings' );
            const newBindings = toggleBinding( id, oldBindings, on );

            this.model.set( 'bindings', newBindings );

            const checkedTypeIds = hashify( newBindings
                .filter( binding => [undefined, true, 't'].includes( binding.on ) )
                .map( binding => binding.type.id ) );
            this.$( '.-toggle-all' )[0].checked = 
                this.getAvailableFilteredModelIds( this.options.typesFiltered ).every( typeId => checkedTypeIds[typeId] );

            this.Roles.render();
        },

        'click .-toggle-all'({currentTarget}) {
            const on = currentTarget.checked;
            const oldBindings = this.model.get( 'bindings');
            const newBindings = this.getAvailableFilteredModelIds( this.options.typesFiltered )
                .reduce( 
                    (oldBindings, id) => toggleBinding( id, oldBindings, on ),
                    oldBindings );

            this.model.set( 'bindings', newBindings );

            this.$( '.-toggle-binding:not([disabled])' ).toArray()
                .forEach( el => el.checked = on );

            this.Roles.render();
        },

    },

    reSortGrid() {
        const { typesSort: sort, typesDirection: direction } = this.state();
        const { types, typesSorted, } = this.options;

        return Grid.sort( { sort, direction }, types, typesSorted );
    },

    reFilterGrid() {
        const { 
            typesPage: page, typesLimit: limit, typesSearch: search,
            typesActiveId: activeId, } = this.state();
        const { typesSorted, typesFiltered, typesResulted } = this.options;

        Grid.filter( { page, limit, search, activeId, }, 
            this.model.get( 'cluster' ),
            typesSorted, typesFiltered, typesResulted );
    },
    
    reSortRolesVisibleGrid() {
        const { rolesVisibleSort: sort, rolesVisibleDirection: direction } = this.state();
        const { roles, rolesVisibleSorted, } = this.options;

        return Grid.sort( { sort, direction, }, roles, rolesVisibleSorted )
    },

    reFilterRolesVisibleGrid() {
        const { rolesVisiblePage: page, rolesVisibleLimit: limit, } = this.state();
        const { typesResulted } = this.options;
        const { rolesVisibleSorted, rolesVisibleFiltered, rolesVisibleResulted } = this.options;

        Grid.filter( { page, limit }, 
            this.model.get( 'cluster' ) || typesResulted.current() && typesResulted.current().get( 'cluster' ),
            rolesVisibleSorted, rolesVisibleFiltered, rolesVisibleResulted );
    },
    
    reSortRolesEditableGrid() {
        const { rolesEditableSort: sort, rolesEditableDirection: direction } = this.state();
        const { roles, rolesEditableSorted, } = this.options;

        return Grid.sort( { sort, direction, }, roles, rolesEditableSorted )
    },

    reFilterRolesEditableGrid() {
        const { rolesEditablePage: page, rolesEditableLimit: limit, } = this.state();
        const { typesResulted } = this.options;
        const { rolesEditableSorted, rolesEditableFiltered, rolesEditableResulted } = this.options;

        Grid.filter( { page, limit }, 
            this.model.get( 'cluster' ) || typesResulted.current() && typesResulted.current().get( 'cluster' ),
            rolesEditableSorted, rolesEditableFiltered, rolesEditableResulted );
    },

    [FieldFormTemplateModule.event( 'Roles:mode:set' )](rolesMode) {
        return this.setState( { rolesMode, } ), 
            this.navigated(),
            this.Roles.render();
    },
    
    [FieldFormTemplateModule.event( 'TypesPaging:page')](page) {
        return this.setState( { typesPage: +page, } ),
            this.reFilterGrid(),
            this.navigated();
    },

    [FieldFormTemplateModule.event( 'RolesVisiblePaging:page')](page) {
        return this.setState( { rolesVisiblePage: +page, } ),
            this.reFilterRolesVisibleGrid(),
            this.navigated();
    },

    [FieldFormTemplateModule.event( 'RolesEditablePaging:page')](page) {
        return this.setState( { rolesEditablePage: +page, } ),
            this.reFilterRolesEditableGrid(),
            this.navigated();
    },

    [FieldFormTemplateModule.event( 'TypesSearch:search')](search) {
        return this.setState( { typesSearch: search, typesPage: 1, } ), 
            this.reFilterGrid(),
            this.navigated();
    },

    // TypeGrid == form, Grid == grid inside form
    [FieldFormTemplateModule.event( 'Grid:activate' )](index, type) {
        this.setState( { 
            rolesVisiblePage: 1, rolesEditablePage: 1,
            typesActiveId: type.id,
        } );
        this.reFilterRolesVisibleGrid();
        this.reFilterRolesEditableGrid();
        this.Roles.render();
        this.navigated();
    },

    [FieldFormTemplateModule.event( 'Grid:deactivate' )]() {
        this.setState( { 
            typesActiveId: undefined,
        } );
        this.Roles.render();
        this.navigated();
    },

    [FieldFormTemplateModule.event( 'RolesVisibleGrid:role:toggle' )](id) {
        handleToggleRole.call( this,
            id,
            toggleRoleVisible, findVisibleRoles,
            this.$( '[name=RolesVisibleGrid] thead [type=checkbox]' ) );
    },

    [FieldFormTemplateModule.event( 'RolesEditableGrid:role:toggle' )](id) {
        handleToggleRole.call( this,
            id,
            toggleRoleEditable, findEditableRoles,
            this.$( '[name=RolesEditableGrid] thead [type=checkbox]' ) );
    },

    [FieldFormTemplateModule.event( 'RolesVisibleGrid:role:toggle-all' )]() {
        handleToggleAllRoles.call( this,
            toggleRoleVisible, findVisibleRoles,
            this.$( '[name=RolesVisibleGrid] tbody [type=checkbox]:not([disabled])' ) );
    },

    [FieldFormTemplateModule.event( 'RolesEditableGrid:role:toggle-all' )]() {
        handleToggleAllRoles.call( this,
            toggleRoleEditable, findEditableRoles,
            this.$( '[name=RolesEditableGrid] tbody [type=checkbox]:not([disabled])' ) );
    },

    [FieldFormTemplateModule.event( 'Roles:visible-by-default:toggle' )]() {
        const newBindings = toggleByDefaultCheckbox.call( 
            this,
            this.options.typesResulted.current(),
            this.model.get( 'bindings' ),
            'visible_by_default', 
            'visible_inverted_for_roles' );

        this.model.set( 'bindings', newBindings );

        this.Roles.render();
    },

    [FieldFormTemplateModule.event( 'Roles:editable-by-default:toggle' )]() {
        const newBindings = toggleByDefaultCheckbox.call( 
            this,
            this.options.typesResulted.current(),
            this.model.get( 'bindings' ),
            'editable_by_default', 
            'editable_inverted_for_roles' );

        this.model.set( 'bindings', newBindings );

        this.Roles.render();
    },

} );





function makeNewRule() {
    return { 
        visible_by_default: true, 
        visible_inverted_for_roles: [],
        editable_by_default: null,
        editable_inverted_for_roles: null,
    };
}

function toggleBinding(id, oldBindings, on) {
    const containsBinding = oldBindings.find( binding => binding.type.id == id );
    if (on && !containsBinding)
        return [ 
            ...oldBindings, 
            { 
                on: true, 
                type: { id }, 
                rules: [makeNewRule()] 
            }
        ];
    
    return oldBindings.map( binding => binding.type.id != id 
        ? binding
        : ({ ...binding, on }) );
}

function handleToggleRole(id, toggleFn, findRolesFn, $allCheckbox) {
    const type = this.options.typesResulted.current();
    const idsBefore = findRolesFn.call( 
        this, 
        this.model, type );
    const checkedBeforeClick = idsBefore.includes( +id ) || idsBefore.includes( '' + id );
    const checkedAfterClick = !checkedBeforeClick;

    const oldBindings = this.model.get( 'bindings' );
    const newBindings = toggleFn.call( this, id, this.options.typesResulted.current(),
        oldBindings, checkedAfterClick );

    this.model.set( 'bindings', newBindings );

    const idsAfter = hashify( findRolesFn.call( 
        this,
        this.model, type ) );

    $allCheckbox[0].checked = 
        // достаточно поискать список доступых ролей в rolesVisibleFiltered - 
        // результат будет совпадать с поиском по rolesEditableFiltered
        this.getAvailableFilteredModelIds( this.options.rolesVisibleFiltered )
            .every( roleId => idsAfter[roleId] );
}

function toggleRoleVisible(id, type, bindings, checked) {
    return toggleRole.call( this,
        id, type, bindings, checked, 
        'visible_by_default', 'visible_inverted_for_roles' );
}

function toggleRoleEditable(id, type, bindings, checked) {
    return toggleRole.call( this,
        id, type, bindings, checked, 
        'editable_by_default', 'editable_inverted_for_roles' );
}

function handleToggleAllRoles(toggleFn, findRolesFn, $checkboxes) {
    const type = this.options.typesResulted.current();
    const idsBefore = hashify( findRolesFn.call( 
        this,
        this.model, type ) );
    const checkedBeforeClick = 
        // достаточно поискать список доступых ролей в rolesVisibleFiltered - 
        // результат будет совпадать с поиском по rolesEditableFiltered
        this.getAvailableFilteredModelIds( this.options.rolesVisibleFiltered )
            .every( roleId => idsBefore[roleId] );
    const checkedAfterClick = !checkedBeforeClick;

    const oldBindings = this.model.get( 'bindings');
    // достаточно поискать список доступых ролей в rolesVisibleFiltered - 
    // результат будет совпадать с поиском по rolesEditableFiltered
    const newBindings = this.getAvailableFilteredModelIds( this.options.rolesVisibleFiltered )
        .filter( id => checkedAfterClick && !idsBefore[id] || !checkedAfterClick && idsBefore[id] )
        .reduce( 
            (oldBindings, id) => toggleFn.call( this, id, type, oldBindings, checkedAfterClick ),
            oldBindings );

    this.model.set( 'bindings', newBindings );

    $checkboxes.toArray()
        .forEach( el => el.checked = checkedAfterClick );
}

function toggleRole(id, type, bindings, checked, propCheckboxName, propArrayName) {
    return mapEl( bindings,
        
        oldBinding => oldBinding.type.id == type.id,
        
        () => ({ on: false, type: { id: type.id } }),

        oldBinding => 
            mapBinding( this.model, oldBinding, 
                (oldCheckboxValue, oldArrayValue) => {
                    const needAppend = 
                        checked && !oldCheckboxValue || !checked && oldCheckboxValue;
                    const newArrayValue = needAppend
                        ? [...oldArrayValue, +id]
                        : oldArrayValue.filter( roleId => roleId != id );

                    return [oldCheckboxValue, newArrayValue];
                },
                propCheckboxName, propArrayName ) );
}

function toggleByDefaultCheckbox(type, bindings, propCheckboxName, propArrayName) {
    const currentType = this.options.typesResulted.current();
    const currentTypeCluster = currentType ? currentType.get( 'cluster' ) : null;
    const cluster = this.model.get( 'cluster' ) || currentTypeCluster;

    // здесь не нужно отправлять page/limit, потому что они используются в resulted,
    // а нам нужен filtered
    const roleIds = Grid.filter( {}, cluster, this.options.rolesVisibleSorted )
        .filtered.toJSON()
        .map( role => +role.id );

    return mapEl( bindings,
        
        oldBinding => oldBinding.type.id == type.id,
        
        () => ({ type: { id: type.id } }),

        oldBinding => 
            mapBinding( this.model, oldBinding, 
                (oldCheckboxValue, oldArrayValue) => [
                    !oldCheckboxValue,
                    roleIds.filter( id => !oldArrayValue.includes( id ) && !oldArrayValue.includes( '' + id ) )
                ],
                propCheckboxName, propArrayName ) );
}

function mapBinding(model, oldBinding, fn, propCheckboxName, propArrayName) {
    const newRules = mapEl( 

        // что
        oldBinding.rules,

        // когда
        () => true,

        // новый элемент
        makeNewRule,

        // преобразование старого элемента
        oldRule => {
            const oldArrayValue = oldRule[propArrayName] || 
                model.get( 'editable_inverted_for_roles' ) || [];
            const oldCheckboxValue = [true, 't'].includes( oldRule[propCheckboxName] != null
                ? oldRule[propCheckboxName]
                : model.get( 'editable_by_default' ) );

            const [newCheckboxValue, newArrayValue] = fn( oldCheckboxValue, oldArrayValue );

            // rule удаляется, если оно новое, ...
            if (!oldRule.id) {
                const initialCheckboxValue = propCheckboxName === 'editable_by_default'
                    ? [true, 't'].includes( model.get( 'editable_by_default' ) )
                    : true;
                const initialArrayValue = propArrayName === 'editable_inverted_for_roles'
                    ? [...model.get( 'editable_inverted_for_roles' )]
                    : [];

                // ... и ролей в массиве нет и checkbox включен
                // (т.е. соответствует состоянию до начала изменений)
                if (initialCheckboxValue === newCheckboxValue)
                    if (eq( initialArrayValue, newArrayValue ))
                        return undefined;
            }

            return { 
                ...oldRule, 
                [propCheckboxName]: newCheckboxValue,
                [propArrayName]: newArrayValue 
            };

        } ); // mapEl-end

    // binding удаляется, если он новый, выключенный и правил больше нет
    // (т.е. производится откат к состоянию до начала изменений)
    if (oldBinding.id || newRules.length || oldBinding.on)
        return { ...oldBinding, rules: newRules };
}

function currentRule(model, type) {
    if (!type)
        return null;

    const [binding] = model.get( 'bindings' )
        .filter( binding => binding.type.id == type.id );

    if (!binding)
        return [true, 't'].includes( model.get( 'is_for_all') )
            ? makeNewRule()
            : null;

    if (![undefined, true, 't'].includes( binding.on ))
        if (![true, 't'].includes( model.get( 'is_for_all') ))
            return null;

    return binding.rules && binding.rules.length
        ? binding.rules[0]
        : makeNewRule();
}

function findVisibleRoles(model, type) {
    const rule = currentRule( model, type );
    if (!rule)
        return [];

    const { visible_by_default, visible_inverted_for_roles: roles } = rule;
    return [false, 'f'].includes( visible_by_default )
        ? roles
        : this.options.roles.toJSON()
            .map( role => +role.id )
            .filter( id => !roles.includes( id ) && !roles.includes( '' + id ) );
}

function findEditableRoles(model, type) {
    const rule = currentRule( model, type );
    if (!rule)
        return [];

    const { editable_by_default, editable_inverted_for_roles } = rule;
    const editable = editable_by_default != null
        ? editable_by_default
        : model.get( 'editable_by_default' );
    const roles = editable_inverted_for_roles != null
        ? editable_inverted_for_roles
        : model.get( 'editable_inverted_for_roles' );

    return [false, 'f'].includes( editable )
        ? roles
        : this.options.roles.toJSON()
            .map( role => +role.id )
            .filter( id => !roles.includes( id ) && !roles.includes( '' + id ) );
}


// WEBPACK FOOTER //
// ./src/js/module/refbooks/fields.form.types.js